module.exports = __webpack_public_path__ + "static/media/user-default-avatar.8566a5dc.png";